import React, { Component } from 'react';
import { string, func } from 'prop-types';

export default class Input extends Component {
  render() {
    const { ref, placeholder, onChange, type, value, className, formControl=true, ...other } = this.props
    return (
      <input
        ref={ref}
        className={`${formControl ? 'form-control' : ''} ${className}`}
        placeholder={placeholder}
        type={type}
        onChange={onChange}
        value={value}
        {...other}
      />
    )
  }
}

Input.propTypes = {
  placeholder: string,
  type: string,
  onChange: func
};

Input.defaultProps = {
  placeholder: 'Input...',
  type: 'text',
  onChange: () => { }
};